<template>
  <button class="btn btn-md md:btn-lg btn-primary-reverse w-max mx-auto">
    Load More
  </button>
</template>

<script setup></script>

<style lang="scss" scoped></style>
